import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displaySymbolForZeroPo'
})
export class DisplaySymbolForZeroPoPipe implements PipeTransform {

  transform(value: number | string): unknown {
    return value === 0 || value === '0'? '-' : value;
  }
}
